import { AUTOMATIONS_PAGE } from 'src/constants';
import { useFeatureFlags } from 'src/context';

export const SETTINGS_AUTOMATIONS_PATH = `/settings${AUTOMATIONS_PAGE.path}`;

/**
 * Returns the base path for automations pages.
 * When EnableStudioSidebar is on, automations live under /settings/automations
 * so the settings sidebar stays visible.
 */
export function useAutomationsBasePath(): string {
  const { EnableStudioSidebar } = useFeatureFlags();
  return EnableStudioSidebar
    ? SETTINGS_AUTOMATIONS_PATH
    : AUTOMATIONS_PAGE.path;
}
